import React, { useState } from "react";
import "flag-icons/css/flag-icons.min.css";
import InstagramLink from "./InstagramLink";
import TiktokLink from "./TiktokLink";
import { Link } from "react-router-dom";

interface NavigationProps {
  locale: string;
  setLocale: (locale: string) => void;
  showHeader: boolean;
}

export const Navigation: React.FC<NavigationProps> = ({ locale, setLocale, showHeader }) => {
  // Control whether the "Aprende más" dropdown is open
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // Control hamburger collapse (true means collapsed)
  const [navCollapsed, setNavCollapsed] = useState(true);

  // Handlers to open and close the dropdown via mouse events
  const handleMouseEnter = () => setDropdownOpen(true);
  const handleMouseLeave = () => setDropdownOpen(false);

  // When a dropdown option is clicked, close both the dropdown and the hamburger menu
  const handleDropdownClick = () => {
    setDropdownOpen(false);
    setNavCollapsed(true);
  };

  // When any nav link is clicked, close the hamburger menu
  const handleNavLinkClick = () => setNavCollapsed(true);

  // Toggle hamburger menu on button click
  const toggleNavbar = () => setNavCollapsed(!navCollapsed);

  return (
    <nav
      id="menu"
      className="navbar navbar-default navbar-fixed-top"
      style={{
        transition: "transform 0.3s ease",
        transform: showHeader ? "translateY(0)" : "translateY(-100%)",
      }}
    >
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            onClick={toggleNavbar}
          >
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <Link
            className="navbar-collapse navbar-brand page-scroll"
            to="/"
            onClick={(e) => {
              handleNavLinkClick();
              // Always scroll to top, even if already on home page
              setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }, 10);
            }}
          >
            <span style={{ color: "#1e4b9e" }}>Endo</span>
            <span style={{ color: "#da83b7" }}>Comunidad</span>
            <img src="../img/logo.svg" className="logo" alt="" />
          </Link>
        </div>

        <div
          className={`collapse navbar-collapse ${navCollapsed ? "" : "in"}`}
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a
                href="/#por_que"
                className="page-scroll"
                onClick={(e) => {
                  handleNavLinkClick();
                  if (window.location.pathname === "/") {
                    e.preventDefault();
                    window.history.pushState(null, '', '/#por_que');
                    setTimeout(() => {
                      document.getElementById("why")?.scrollIntoView({ behavior: "smooth" });
                    }, 100);
                  }
                }}
              >
                <strong>¿Por qué?</strong>
              </a>
            </li>
            <li>
              <a
                href="/#considera"
                className="page-scroll"
                onClick={(e) => {
                  handleNavLinkClick();
                  if (window.location.pathname === "/") {
                    e.preventDefault();
                    window.history.pushState(null, '', '/#considera');
                    setTimeout(() => {
                      document.getElementById("consider")?.scrollIntoView({ behavior: "smooth" });
                    }, 100);
                  }
                }}
              >
                <strong>Ten en cuenta</strong>
              </a>
            </li>
            <li>
              <a
                href="/#acerca"
                className="page-scroll"
                onClick={(e) => {
                  handleNavLinkClick();
                  if (window.location.pathname === "/") {
                    e.preventDefault();
                    window.history.pushState(null, '', '/#acerca');
                    setTimeout(() => {
                      document.getElementById("about")?.scrollIntoView({ behavior: "smooth" });
                    }, 100);
                  }
                }}
              >
                <strong>Acerca</strong>
              </a>
            </li>
            <li>
              <a
                href="/#guia"
                className="page-scroll"
                onClick={(e) => {
                  handleNavLinkClick();
                  if (window.location.pathname === "/") {
                    e.preventDefault();
                    window.history.pushState(null, '', '/#guia');
                    setTimeout(() => {
                      document.getElementById("guide")?.scrollIntoView({ behavior: "smooth" });
                    }, 100);
                  }
                }}
              >
                <strong>Endoguía</strong>
              </a>
            </li>
            {/* <li>
              <Link
                to="/reviews"
                className="page-scroll"
                onClick={handleNavLinkClick}
              >
                <strong>Reseñas</strong>
              </Link>
            </li> */}
            {/* <li>
              <a
                href="/#collaborators"
                className="page-scroll"
                onClick={handleNavLinkClick}
              >
                <strong>Colaboradores</strong>
              </a>
            </li> */}
            <li
              className="dropdown"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {/* The root link goes to /aprende */}
              <Link
                to="/aprende"
                className="page-scroll dropdown-toggle"
                data-toggle="dropdown"
                onClick={handleDropdownClick}
              >
                <strong>Aprende más</strong> <span className="caret"></span>
              </Link>
              <ul
                className="dropdown-menu"
                style={{ display: dropdownOpen ? "block" : "none" }}
              >
                <li>
                  <Link
                    to="/aprende"
                    className="page-scroll"
                    onClick={(e) => {
                      handleDropdownClick();
                      if (window.location.pathname === "/aprende" && !window.location.hash) {
                        e.preventDefault();
                        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                      }
                    }}
                  >
                    ¿Qué es la endometriosis?
                  </Link>
                </li>
                <li>
                  <Link
                    to="/aprende#endometriosis"
                    className="page-scroll"
                    onClick={(e) => {
                      handleDropdownClick();
                      if (window.location.pathname === "/aprende") {
                        e.preventDefault();
                        window.history.pushState(null, '', '/aprende#endometriosis');
                        setTimeout(() => {
                          document.getElementById("endometriosis")?.scrollIntoView({ behavior: "smooth" });
                        }, 100);
                      }
                    }}
                  >
                    Endometriosis y endometrio
                  </Link>
                </li>
                <li>
                  <Link
                    to="/aprende#causa"
                    className="page-scroll"
                    onClick={(e) => {
                      handleDropdownClick();
                      if (window.location.pathname === "/aprende") {
                        e.preventDefault();
                        window.history.pushState(null, '', '/aprende#causa');
                        setTimeout(() => {
                          document.getElementById("cause")?.scrollIntoView({ behavior: "smooth" });
                        }, 100);
                      }
                    }}
                  >
                    ¿Cuál es su causa?
                  </Link>
                </li>
                <li>
                  <Link
                    to="/aprende#tipos"
                    className="page-scroll"
                    onClick={(e) => {
                      handleDropdownClick();
                      if (window.location.pathname === "/aprende") {
                        e.preventDefault();
                        window.history.pushState(null, '', '/aprende#tipos');
                        setTimeout(() => {
                          document.getElementById("types")?.scrollIntoView({ behavior: "smooth" });
                        }, 100);
                      }
                    }}
                  >
                    Tipos de endometriosis
                  </Link>
                </li>
                <li>
                  <Link
                    to="/aprende#sintomas"
                    className="page-scroll"
                    onClick={(e) => {
                      handleDropdownClick();
                      if (window.location.pathname === "/aprende") {
                        e.preventDefault();
                        window.history.pushState(null, '', '/aprende#sintomas');
                        setTimeout(() => {
                          document.getElementById("symptoms")?.scrollIntoView({ behavior: "smooth" });
                        }, 100);
                      }
                    }}
                  >
                    Síntomas
                  </Link>
                </li>
                <li>
                  <Link
                    to="/aprende#diagnostico"
                    className="page-scroll"
                    onClick={(e) => {
                      handleDropdownClick();
                      if (window.location.pathname === "/aprende") {
                        e.preventDefault();
                        window.history.pushState(null, '', '/aprende#diagnostico');
                        setTimeout(() => {
                          document.getElementById("diagnosis")?.scrollIntoView({ behavior: "smooth" });
                        }, 100);
                      }
                    }}
                  >
                    Diagnóstico
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <InstagramLink />
            </li>
            <li>
              <TiktokLink />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};